require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/fn/object/create.js
// module id = 1455
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16